import { createSelector } from 'reselect';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getState } from './state';
import { getList } from './identity';
import { PROMOTIONS_STREAM_ID } from '../../constants';
import { getDrawerStreamId } from '../../utils';
import { getActiveFolder } from './options';

export const getHasGroups = createSelector(
  [getState, getList],
  (state, list) => state.drawer?.hasGroups || list.length > 1
);

export const getHasUnread = createSelector([getList], list =>
  list.some(item => item.newCount && item.newCount > 0)
);

export const getUnreadCount = createSelector([getList], list =>
  list.reduce((acc, curr) => acc + curr.newCount!, 0)
);

export const getDrawerElninos = state =>
  streamSelectors.getItems(state, PROMOTIONS_STREAM_ID) ?? [];

export const getActiveDrawerStreamParams = createSelector(
  [getActiveFolder],
  folder => ({ folder })
);

export const getActiveDrawerStreamId = createSelector(
  [getActiveDrawerStreamParams],
  params => getDrawerStreamId(params)
);

export const isDrawerEmpty = createSelector(
  [state => state, getActiveDrawerStreamId],
  (state, streamId) => {
    if (!streamId) {
      return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
      return false;
    }

    const stream = streamSelectors.getStream(state, streamId);
    return stream.items.length === 0 && !stream.isFetching && !stream.hasMore;
  }
);

export const getLatestTs = createSelector(
  [state => state, getActiveDrawerStreamId],
  (state, streamId) => {
    if (!streamId) {
      return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
      return false;
    }
    const stream = streamSelectors.getStream(state, streamId);
    return stream.items[0]?.bucket?.ts;
  }
);

export const getReplyMessageTypeFromDrawerStream = createSelector(
  [
    state => state,
    getActiveDrawerStreamId,
    (state, messageId: string) => messageId,
  ],
  (state, streamId, messageId) => {
    if (!streamId) {
      return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
      return false;
    }
    const stream = streamSelectors.getItems(state, streamId);
    const drawerItem = stream.find(
      item => item?.message?.messageId === messageId
    );
    if (!drawerItem) {
      return false;
    }
    return drawerItem.message.type;
  }
);
